module.exports = __webpack_public_path__ + "static/4-2-b43d5e95acde677e40cc09bcee27ef90.gif";